import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { getContentBlock } from '../../slices/content-block-slice';
import { AnimatedDashboard } from '../../components';
import { colors } from '../../styles/GlobalStyles';

export const PrivacyPolicy = () => {
  const dispatch = useAppDispatch();
  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 120, languageId: 1 }));
  }, [dispatch]);

  return (
    <AnimatedDashboard dark>
      {loading ? (
        <Spinner fullScreen={true} />
      ) : (
        <div
          style={{
            maxWidth: '800px',
            margin: '50px auto 0 auto',
            color: colors.neutral0
          }}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlock && contentBlock.content
            }}
          />
        </div>
      )}
    </AnimatedDashboard>
  );
};
